import { queryKeys, sdk } from 'utils/query';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';
import { removeWhiteSpace } from 'utils/helpers';
import { CallBackProps, MfaType } from 'models/general';
import { RecoveryCodesMethod } from '@extrahorizon/javascript-sdk';
import { useCustomMutation } from '../../useCustomMutation';

interface VerifyMfaProps {
  userId?: string;
  methodId: string;
  presenceToken: string;
  sixDigitCode: string;
  completeVerificationCallback: (result: RecoveryCodesMethod) => void;
}

const verifyMfaCode = async ({ userId, methodId, presenceToken, sixDigitCode }: VerifyMfaProps & CallBackProps) => {
  if (!userId) throw new EmptyParametersError();

  await sdk.auth.users.confirmMfaMethodVerification(userId, methodId, {
    presenceToken,
    code: removeWhiteSpace(sixDigitCode),
  });

  await sdk.auth.users.enableMfa(userId, { presenceToken });

  return await sdk.auth.users.addMfaMethod(userId, {
    presenceToken,
    type: MfaType.RecoveryCodes,
    name: MfaType.RecoveryCodes,
    tags: [],
  });
};

export const useVerifyMfa = () => {
  return useCustomMutation({
    fn: verifyMfaCode,
    onSuccess: {
      invalidateQueryKeys: [[queryKeys.userData]],
      callback: async (data, variables) => {
        variables.completeVerificationCallback(data);
      },
    },
  });
};
